<template>
  <v-btn
    v-if="personId != null"
    class="person-link px-1 text-none"
    variant="text"
    size="small"
    color="primary"
    :to="{ name: 'person-view', params: { id: personId } }"
    @click.stop
  >
    {{ label }}
  </v-btn>
  <span v-else>{{ label }}</span>
</template>

<script setup lang="ts">
/** The one clickable person name used across staff tables and pages. */
const props = withDefaults(
  defineProps<{
    personId?: number | null;
    name?: string | null;
    /** Shown when there is no name; falls back to `Person #id` when an id is known. */
    fallback?: string;
  }>(),
  { personId: null, name: null, fallback: "--" },
);

const label = computed(() => {
  const name = props.name?.trim();
  if (name) return name;
  return props.personId != null ? `Person #${props.personId}` : props.fallback;
});
</script>

<style scoped>
.person-link {
  letter-spacing: normal;
  min-width: 0;
}
</style>
